module.exports = __webpack_public_path__ + "media/application/images/svgs/link-2-b5d80657c0bb4d734a19fef327af905e.svg";